export default function stackid(state = '', action) {
  if (action.type === 'stackid') {
    return state = action.id;
  } else {
    return state;
  }
}
